import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportingMemberDtlsComponent } from './reporting-member-dtls/reporting-member-dtls.component';
import { CounterPartyDtlsComponent } from './counter-party-dtls/counter-party-dtls.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AmrtAcrtScheduleComponent } from './amrt-acrt-schedule/amrt-acrt-schedule.component';
import { FixedInterestComponent } from './fixed-interest/fixed-interest.component';
import { FloatInterestComponent } from './float-interest/float-interest.component';



@NgModule({
  declarations: [ReportingMemberDtlsComponent, CounterPartyDtlsComponent, AmrtAcrtScheduleComponent, FixedInterestComponent, FloatInterestComponent],
  imports: [
    CommonModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
  ],
  exports: [ReportingMemberDtlsComponent, CounterPartyDtlsComponent, AmrtAcrtScheduleComponent, FixedInterestComponent, FloatInterestComponent]
})
export class CommonComponentsModule { }
